import { CASH_TRANSACTIONS } from '../actionTypes';

export const fetchCashTransactions = (action) => ({
  type: CASH_TRANSACTIONS.FETCH,
  payload: action.payload,
});
